export default __webpack_public_path__ + "static/aman-71cae7ed8a1b4bc656a89051801686c5.png";